import { State } from './type'

const state: State = {
    addState: false,
    detail: null,
}

const mutations = {
    togglePackageAddState(state: { addState: boolean }, value: boolean) {
        state.addState = value
    },
    setPackageDetail(state: { detail: null | Object }, value: Object | null) {
        state.detail = value
    },
}

export default {
    state,
    mutations,
}
